import { render, staticRenderFns } from "./SelectVat.vue?vue&type=template&id=895db526"
import script from "./SelectVat.vue?vue&type=script&lang=ts"
export * from "./SelectVat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports